import axiosHttp from "services/axiosHttp";
import { REWARD_BASE_URL } from "configs/AppConfig";
import moment from "moment";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchCashReport = createAsyncThunk(
  "fetchCashReport",
  async ({ channel_uuid, filters }, { rejectWithValue }) => {
    let start_date = "";
    let end_date = "";

    if (filters?.range?.length === 2) {
      start_date = moment(filters.range[0].$d).format("YYYY-MM-DD");
      end_date = moment(filters.range[1].$d).format("YYYY-MM-DD");
    }
    const params = new URLSearchParams({
      channel: channel_uuid || "",
      terminal: filters?.terminal || "",
      startDate: start_date || "",
      endDate: end_date || "",
      cashierUUID: filters?.cashier || "",
      payment_method: filters?.payment_method || "",
      customerType: filters?.customer_type || "",
    });
    try {
      const response = await axiosHttp.get(
        `${REWARD_BASE_URL}cash-report-details?${params}`
      );
      return response.data.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
const CashReportSlice = createSlice({
  name: "CashReportSlice",
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCashReport.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(fetchCashReport.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });
    builder.addCase(fetchCashReport.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export default CashReportSlice.reducer;
